var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscountSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b52025",
    d: "M12 2.1L15.2 0 17 3.4l3.8-.2-.2 3.8L24 8.8 21.9 12l2.1 3.2-3.4 1.8.2 3.8-3.8-.2-1.8 3.4-3.2-2.1L8.8 24 7 20.6l-3.8.2.2-3.8L0 15.2 2.1 12 0 8.8 3.4 7l-.2-3.8 3.8.2L8.8 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 12.2c-.5-.6-.7-1.4-.7-2.5s.2-2 .7-2.5c.5-.6 1.1-.9 2-.9.8 0 1.5.3 2 .9.5.6.7 1.4.7 2.5s-.2 2-.7 2.5c-.5.6-1.1.9-2 .9-.9 0-1.5-.3-2-.9zm3.1-.6c.2-.4.4-1 .4-1.9 0-.9-.1-1.5-.4-1.9-.2-.4-.6-.6-1.1-.6s-.9.2-1.2.6c-.3.4-.4 1-.4 1.9 0 .9.1 1.5.4 1.9.3.4.6.6 1.2.6s.9-.2 1.1-.6zM9 17.8c-.1 0-.3 0-.4-.1-.1-.1-.1-.2-.1-.4 0-.1 0-.2.1-.4l6-10.4c.1-.2.3-.3.5-.3.1 0 .3.1.4.1.1.1.1.2.1.4 0 .1 0 .2-.1.4l-6 10.4c-.1.2-.3.3-.5.3zm4.9-1c-.5-.6-.7-1.4-.7-2.5s.2-2 .7-2.5c.5-.6 1.1-.9 2-.9.9 0 1.5.3 2 .9.5.6.7 1.4.7 2.5s-.2 2-.7 2.5c-.5.6-1.1.9-2 .9-.9-.1-1.6-.4-2-.9zm3.1-.7c.2-.4.4-1 .4-1.9 0-.9-.1-1.5-.4-1.9-.3-.4-.6-.6-1.2-.6-.5 0-.9.2-1.1.6-.2.4-.4 1-.4 1.9 0 .9.1 1.5.4 1.9.2.4.6.6 1.1.6.6 0 1-.2 1.2-.6z",
    fill: "#fff"
  })));
}

export default SvgDiscountSmall;